<template>
  <div class="cm-paginiation-row">
    <div class="cm-paginiation-content">
      <div class="cm-paginiation-select">
        <v-select v-model="itemsPerPage" :items="itemsPerPageOptions" label="Rows per page: "></v-select>
      </div>
      <div class="cm-paginiation-select">
        <p></p>
        <v-select v-model="currentPage" :items="pageOptions" label="Page: "></v-select>
      </div>
      <v-icon large :disabled="currentPage == 1" @click="currentPage = 1">mdi-chevron-double-left</v-icon>
      <v-icon large :disabled="currentPage < 2" @click="currentPage--">mdi-chevron-left</v-icon>
      <v-icon large :disabled="currentPage == totalPages" @click="currentPage++">mdi-chevron-right</v-icon>
      <v-icon large :disabled="currentPage == totalPages" @click="currentPage = totalPages">mdi-chevron-double-right</v-icon>
      <v-icon v-if="showDownload" large @click="$emit('download')">mdi-download</v-icon>
    </div>
  </div>  
</template>

<script>
export default {
  props: {
    items: {
      type: Number,
      default: () => 1
    },
    showDownload: {
      type: Boolean,
      default: () => false
    }
  },

  data () {
    return {
      itemsPerPage: 20,
      itemsPerPageOptions: [10, 20, 50, 75, 100],
      currentPage: 1
    }
  },

  computed: {
    totalPages () {
      try {
        return Math.ceil(this.items / this.itemsPerPage)
      } catch {
        return 1
      }
    },
    pageOptions () {
      const pages = []
      for(let x = 1; x <= this.totalPages; x++) {
        pages.push(x)
      }
      return pages
    }
  },

  watch: {
    items () {
      this.currentPage = 1
    },

    itemsPerPage() {
      this.currentPage = 1
      this.$emit('updated', {page: this.currentPage, itemsPerPage: this.itemsPerPage})
    },

    currentPage() {
      this.$emit('updated', {page: this.currentPage, itemsPerPage: this.itemsPerPage})
    }
  }
}
</script>

<style lang="scss" scoped>
.cm-paginiation-row {
  display: flex;
  width: 100%;
  flex-direction: row-reverse;

  .cm-paginiation-content {
    display: flex;
    padding: 10px 30px 10px 30px;
  }

  .cm-paginiation-select {
    display: flex;
    width: 100px;
    margin-right: 20px;
  }
}
</style>